import axios from "axios";
import React, { useState } from "react";
import Menu from "./Components/Menu";
// import { Routes, Route } from "react-router-dom";
// import Cart from "./Components/Cart";
// import Menu from "./Components/Menu";
// import Restaurants from "./Components/Restaurants";
// import TrackOrder from "./Components/TrackOrder";
// import Footer from "./UI/Footer";
import Main from "./UI/Main";

function App() {
  const [query, setQuery] = useState("");
  const [recipes, setRecipes] = useState([]);
  const [CuisineType, setCuisineType] = useState("indian");
  const url = `https://api.edamam.com/api/recipes/v2?type=public&q=${query}&app_id=a9044b26&app_key=522ef4b7287a2dc8e659c0e25c0d5f7e&&cuisineType
  =${CuisineType}`;
  async function getRecipes() {
    await axios
      .get(url)
      .then((resp) => {
        setRecipes(resp.data.hits);
        console.log(resp.data);
      })
      .catch((err) => {
        console.log(err.data);
      });
  }

  const Submit = (e) => {
    e.preventDefault();
    getRecipes();
  };

  return (
    <div className="App">
      <Main />
      <form onSubmit={Submit}>
        <div className="inline-grid justify-center grid-cols-5 mx-96">
          <input
            className="max-w-fit box-border border-x-2 border-x-emerald-300 outline-none p-2 text-amber-600"
            placeholder="search food"
            type="text"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
            }}
          />
          <button
            type="submit"
            value="search"
            className="box-border w-fit rounded-lg border-2 bg-amber-500 text-xl hover:bg-amber-600 "
          >
            Search
          </button>
        </div>
        <select className="box-border border-b-2 border-b-emerald-300 outline-none">
          <option
            onClick={() => {
              setCuisineType("indian");
            }}
          >
            Indian
          </option>
          <option
            onClick={() => {
              setCuisineType("american");
            }}
          >
            American
          </option>

          <option
            onClick={() => {
              setCuisineType("central europe");
            }}
          >
            Central Europe
          </option>

          <option
            onClick={() => {
              setCuisineType("french");
            }}
          >
            Frech
          </option>

          <option
            onClick={() => {
              setCuisineType("middle eastern");
            }}
          >
            Middle Eastern
          </option>

          <option
            onClick={() => {
              setCuisineType("chinese");
            }}
          >
            Chinese
          </option>
        </select>
      </form>

      <div>
        {recipes.map((recipe) => {
          return <Menu recipe={recipe} />;
        })}
      </div>
    </div>
  );
}

export default App;
